export const ASSETS_ADD_JS = 'ASSETS_ADD_JS';
export const ASSETS_ADD_CSS = 'ASSETS_ADD_CSS';

export function addAsset(type, uri) {
  switch (type) {
    case 'js':
      return {
        type: ASSETS_ADD_JS,
        uri
      };
    case 'css':
      return {
        type: ASSETS_ADD_CSS,
        uri
      };
    default:
      return {};
  }
}
